// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ff533ae","455":"a0103eb2","977":"553ae97b"}[chunkId] + ".chunk.js";
};